export enum AnonymizationProcessingState {
  NOT_PROCESSED = 'not_processed',
  PROCESSING = 'processing',
  PROCESSED = 'processed',
  PROCESSED_WITH_ERROR = 'processed_with_error',
}
